import { schema } from 'normalizr';

// eslint-disable-next-line import/prefer-default-export
export const practiceUserSchema = new schema.Entity('practiceUsers');
